import { UserDetails } from '@/modules/UserDetails'
import { Time } from '@/components/Time'
import { Navigation } from '@/components/Navigation'
import styles from './Header.module.scss'
import LogoIcon from '../assets/logo.svg'
import { OfflineLabel } from './OfflineLabel'

export const Header = () => {
    return (
        <header className={styles.header}>
            <section className={styles.logo}>
                <LogoIcon />
                <OfflineLabel />
                <Navigation />
            </section>

            <section className={styles.actions}>
                <Time />
                <UserDetails />
            </section>
        </header>
    )
}
